import type React from 'react';

import { PageBody } from '../components/PageBody';
import { PageMeta } from '../components/PageMeta';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();

	return (
		<>
			<PageMeta />
			<PageBody />
		</>
	);
};
